export const GET_PRESTATIONS = "GET_PRESTATIONS"
export const GET_PRESTATIONS_FAIL = "GET_PRESTATIONS_FAIL"
export const GET_PRESTATIONS_SUCCESS = "GET_PRESTATIONS_SUCCESS"

export const ADD_NEW_PRESTATION = "ADD_NEW_PRESTATION"
export const ADD_PRESTATION_SUCCESS = "ADD_PRESTATION_SUCCESS"
export const ADD_PRESTATION_FAIL = "ADD_PRESTATION_FAIL"

export const UPDATE_PRESTATION = "UPDATE_PRESTATION"
export const UPDATE_PRESTATION_SUCCESS = "UPDATE_PRESTATION_SUCCESS"
export const UPDATE_PRESTATION_FAIL = "UPDATE_PRESTATION_FAIL"

export const DELETE_PRESTATION = "DELETE_PRESTATION"
export const DELETE_PRESTATION_SUCCESS = "DELETE_PRESTATION_SUCCESS"
export const DELETE_PRESTATION_FAIL = "DELETE_PRESTATION_FAIL"





